import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { Observable } from "rxjs";
import { PosCampanhaServiceAba3 } from "../../../service/posCampanhaAba3/pos-campanha-aba3.service";
import { DadosAuxSaudePosRecadDto } from "./dadosAuxSaudePosRecad.dto";
import { MatTableDataSource } from "@angular/material/table";
import { ServidorRecad } from "../../../model/servidorRecad";
import { ThemePalette } from "@angular/material/core";
import { ToastrService } from "ngx-toastr";
import { ModalComponent } from "app/components/modal/modal.component";
import { MatDialog } from "@angular/material/dialog";



type DadosTabela = {
  id: number;
  nome: string;
  plano: string;
  mes: number;
  valorConcedido: number;
  valorPago: number;
  acao: number
  numeroMes: number;
}

@Component({
  selector: 'app-aba3-posrecad',
  templateUrl: './aba3-posrecad.component.html',
  styleUrls: ['./aba3-posrecad.component.sass']
})
export class Aba3PosrecadComponent implements OnInit {


  @Input() servidor: ServidorRecad;
  @Output() flExibirTab: EventEmitter<any> = new EventEmitter<any>();
  @Output() salvoOutput: EventEmitter<any> = new EventEmitter<any>();
  displayedColumns: string[] = ['plano', 'mes', 'valorPago', 'valorConcedido', 'acoes'];
  dataSource: MatTableDataSource<DadosTabela> = new MatTableDataSource<DadosTabela>([]);
  dataSourceDependente: MatTableDataSource<DadosTabela> = new MatTableDataSource<DadosTabela>([]);

  color: ThemePalette = 'primary';
  list: DadosTabela[] = [];
  dependentesAgrupados: {};
  nomeServidor: string
  recadServidorId: number;
  isDisabledJustificativa: boolean = true
  justificativa: string = '';
  dadosPessoais: DadosAuxSaudePosRecadDto;
  salvo: boolean = false;
  totalValorPago: number;
  totalValorPagoConcedido: number;
  totalValorPagoGrupo: number = 0;
  totalValorPagoConcedidoGrupo: number = 0;
  status: number = 0
  caracteresRestantes: number = 2000;


  constructor(private posCampanhaService: PosCampanhaServiceAba3, private toasterService: ToastrService, public dialog: MatDialog) { }

  ngOnInit(): void {

  }

  visualizarComprovante(mes, id, isTitular) {
    this.getVisualizarComprovante(mes, id, isTitular).subscribe(
      response => {
        const blobUrl = URL.createObjectURL(response);

        // Especifica as dimensões da nova janela (largura x altura)
        const newWindow = window.open(blobUrl, '_blank', 'width=800,height=800');

        // Verifica se a janela foi aberta com sucesso
        if (newWindow) {
          newWindow.focus();
        } else {
          this.toasterService.warning('Erro ao abrir a nova janela.', '', {
            timeOut: 1500
          });
        }
      },
      error => {
        this.toasterService.warning('Erro ao visualizar o arquivo.', '', {
          timeOut: 1500
        });
      }
    );
  }

  ngOnDestroy() {

  }

  ngOnChanges(changes: SimpleChanges) {
    this.dataSource.data = [];
    this.list = [];
    this.justificativa = "";
    this.salvo = false;
    this.findLotacao(this.servidor.id)
    this.totalValorPagoGrupo = 0;
    this.totalValorPagoConcedidoGrupo = 0;
  }


  findLotacao(recadServidorId: number) {
    this.getDadosPessoais(recadServidorId).subscribe(
      response => {
        if (response) {
          this.dadosPessoais = response
          this.dataSource.data = this.montarDadosTabela(response.titular)
          this.montarDadosTabelaDepentente(response)
        } else {
          this.flExibirTab.emit(false);
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  private montarDadosTabela(resp: any): DadosTabela[] {
    this.nomeServidor = resp.nome
    resp.meses.forEach(item => {
      this.list.push(
        { id: item.id, nome: item.nome, plano: item.plano, mes: item.mes, valorPago: item.valorPago, valorConcedido: item.valorConcedido, acao: item.mes, numeroMes: item.numeroMes },
      );
    });
    // Calcule o valor total pago
    this.totalValorPago = this.list.reduce((total, element) => {
      if (element.valorPago) {
        return total + element.valorPago;
      }
      return total;
    }, 0);


    this.totalValorPagoConcedido = this.list.reduce((total, element) => {
      if (element.valorPago) {
        return total + element.valorConcedido;
      }
      return total;
    }, 0);
    // // Adicione o valor total pago à lista
    this.list.push({ id: null, nome: '', plano: 'Valor Total', mes: null, valorPago: this.totalValorPago, valorConcedido: this.totalValorPagoConcedido, acao: null, numeroMes: null});
    
    this.calcularTotais(this.totalValorPago, this.totalValorPagoConcedido)
    return this.list;
  }

  private montarDadosTabelaDepentente(resp: any): any {
    const listDependente = resp;

    // Crie uma única instância de MatTableDataSource para todos os dados
    const dataSource = new MatTableDataSource<any>([]);

    // Itere sobre os dependentes e adicione seus dados ao dataSource
    for (let index = 0; index < listDependente.dependentes.length; index++) {
      const dependente = listDependente.dependentes[index];
      dataSource.data.push({
        nome: dependente.nome,
        meses: dependente.meses
      });

      let totalValorPago = 0;
      let totalValorConcedido = 0;

      for (const mes of dependente.meses) {
        totalValorPago += mes.valorPago || 0;
        totalValorConcedido += mes.valorConcedido || 0;
      }
      dependente.meses.push({
        plano: 'Valor Total',
        valorPago: totalValorPago,
        valorConcedido: totalValorConcedido
      });

      // Adicionar os totais ao objeto do dependente
      dependente.totalValorPago = totalValorPago;
      dependente.totalValorConcedido = totalValorConcedido;
      this.calcularTotais(totalValorPago, totalValorConcedido)


    }

    // Atribua o dataSource à propriedade dataSourceDependente
    this.dataSourceDependente = dataSource;
    return dataSource;
  }

  calcularTotais(totalPago: number, totalValorConcedido: number) {

    this.totalValorPagoGrupo += totalPago;
    this.totalValorPagoConcedidoGrupo += totalValorConcedido;
  }

  private getDadosPessoais(recadServidorId: number): Observable<any> {
    return this.posCampanhaService.getDadosAuxSaude(recadServidorId);
  }

  private getVisualizarComprovante(mes: number, id: number, isTitular: number): Observable<any> {
    return this.posCampanhaService.getArquivoAuxSaude(mes, id, isTitular);
  }
  openDialog(): void {
    this.dialog.open(ModalComponent, {
      width: '450px',
      data: {
        header: 'Justificativa',
        descricao: 'Justifique o motivo de recusa:',
        labelOne: 'Cancelar',
        labelTwo: 'Salvar',
        flTextArea: true,
        action: (justificativa: string) => {
          this.justificativa = justificativa;
          this.salvar(3)
        }
      }
    });
  }

  rejeitar(status) {
    this.isDisabledJustificativa = false
    this.openDialog();

    // if (this.justificativa == '') {
    //   this.toasterService.warning('Atenção: O campo justificativa é obrigatório.');
    //   return
    // }
    // else {
    //   this.salvar(status)
    // }
  }


  salvar(status) {
    /*
    status
    1- aceito
    2-pendente
    3- recusado
    * */
    if(status == 1){
      this.justificativa = ''
    }
    let body = {
      recadServidorId: this.servidor.recadServidorId,
      status: status,
      justificativa: this.justificativa,
     
    }
    this.posCampanhaService.postAuxSaude(body).subscribe( resp => {
      this.toasterService.success("Dados salvos com sucesso");
      this.salvo = true;
      this.salvoOutput.emit(true);
    }, error => {
      this.salvo= false
      this.toasterService.error('Erro ao salvar os dados.', '', {
        timeOut: 1500, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
      });

    });
  }
}

